import { useMutation } from '@apollo/client';
import { useCallback, use, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { AUTHORIZE_SMARTRECRUITERS } from '../../behavior/queries/integration';
import LocaleContext from '../hooks/LocaleContext';

export function SmartRecruitersConsent() {
  const { userSettings } = use(LocaleContext);
  const search = useLocation().search;
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [authorizeSmartRecruiters] = useMutation(AUTHORIZE_SMARTRECRUITERS);

  const searchParams = new URLSearchParams(search);
  const companyId = searchParams.get('companyId');
  const redirect = decodeURIComponent(searchParams.get('sr_redirect') ?? '');

  const authorize = useCallback(
    async (companyId: string | null, clientId: string) => {
      setLoading(true);
      try {
        const response = await authorizeSmartRecruiters({
          variables: {
            companyId,
            clientId,
          },
        });

        if (response.data.integrateSmartRecruiters.success) {
          window.location.href = redirect;

          return;
        }

        if (response.data.integrateSmartRecruiters.__typename !== 'SmartRecruitersIntegrationSuccess') {
          setLoading(false);
          setError(response.data.integrateSmartRecruiters.message);
        }
      } catch (error) {
        console.log(error);
        setLoading(false);
        if (error instanceof Error) setError(error.message);
      }
    },
    [authorizeSmartRecruiters, redirect],
  );

  useEffect(() => {
    if (userSettings.company?.id) {
      authorize(companyId, userSettings.company.id);
    }
  }, [authorize, companyId, userSettings.company?.id]);

  if (loading) {
    return `Please wait a moment as we authorize SmartRecruiters. You will be redirected back to SmartRecruiters once the authorization is complete.`;
  }

  if (error) {
    return error;
  }
}
